import { watchDebounced } from '@vueuse/core'
import WindowStore from '@/store/window'



const SCREENS = {
  '2xs': { id: '2xs', position: 0, max: 0 },
  xs: { id: 'xs', position: 1, max: 350 },
  sm: { id: 'sm', position: 2, max: 680 },
  md: { id: 'md', position: 3, max: 880 },
  lg: { id: 'lg', position: 4, max: 1024 },
  xl: { id: 'xl', position: 5, max: 1280 }
}

export const getMatchingScreens = () => {
  const windowStore = WindowStore()
  const { windowWidth } = storeToRefs(windowStore)

return Object.values(SCREENS).filter(
    (s, i) => windowWidth.value >= s.max || i === 0
  )
}

export const getCurrentScreen = () => {
  const result = computed(() => {
    const matchingScreens = getMatchingScreens()
    return matchingScreens[matchingScreens.length - 1] ?? null
  })

  return result
}

export const getValueByScreen = <T>(values: Array<T>) => {
  const windowStore = WindowStore()
  const { windowWidth } = storeToRefs(windowStore)
  
  const result = ref()

  const getResult = () => {
    const screen = getCurrentScreen()
    const matchingValues = values.filter(
      (v, i) => i <= (screen.value?.position ?? 0)
    )

    const value = matchingValues[matchingValues.length - 1]
    result.value = value !== undefined ? value : values[0]
  }

  // onMounted(() => setTimeout(() => getResult()) )
  watchDebounced(windowWidth, () => getResult(), { debounce: 100, immediate: true })

  return {
    result
  }
}
